<template>
    <!-- Form -->
  <el-form :model="problemForm" :rules="rules" ref="problemForm">
    <el-form-item class="infoInput"  prop="desc">
        <el-input type="textarea" maxlength="500" :autosize="{ minRows: 6, maxRows: 10}" placeholder="请输入问题" v-model="problemForm.desc"></el-input>
    </el-form-item>
    <el-form-item class="submitProblem">
        <el-button type="primary" @click="submitProblem('problemForm')">提 交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>

import SendCode from '../../../public/sendCode'
import {checkDesc} from '../../../config/formCheck'

export default {
  name: "feedback",
  props: ['userInfo'],
  components: {
        sendCode:SendCode
        },
  data() {
    return {
        showBox:false,   
        rules: {
          desc: [
            { validator: checkDesc, trigger: 'change' }
          ],
        },
        problemForm: {
            desc:'',
        },
        codeInfo:{
          errorMsg:"",
          codeName:"problemCode"
        },
            
    };
  },
  methods:{
      submitProblem(problemForm){
        let self = this  
        self.$refs['problemForm'].validate((valid) => {
          if(valid){
                        const loading = this.$loading({
                            lock: true,
                            text: '正在验证中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                            });
                        const phoneNo = sessionStorage.getItem('officeEmail_phoneNo')
                        const userInfo = sessionStorage.getItem('officeEmail_userInfo')
                        const token = self.md5(sessionStorage.getItem('officeEmail_token'))
                        const context = self.problemForm.desc
                        const url = '/email/sendEmail?&phoneNo='+phoneNo+
                                    '&token='+token+
                                    '&context='+context
                        self.postRequest(url,userInfo).then((result)=>{
                            console.log("发送短信：",result)
                             loading.close();                             
                             const _result = JSON.stringify(result.data)
                             console.log(_result)
                             console.log(_result.msgStatus)
                            if(result.data.msgStatus == 1){
                                this.$emit('closeBox', {closeBox:false})
                                self.$refs['problemForm'].resetFields();
                                self.$message({
                                    showClose: true,
                                    message: '问题已提交，我们会尽快给你回复',
                                    type: 'success'
                                    });
                            }else if(result.data.msgStatus == 2){
                                self.codeInfo.errorMsg = result.data.msgCode
                            }else{
                                self.$alert('网络错误...', '错误提示', {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true,
                                customClass:'errMessage'
                                });
                            }
                        })
             
                  
          }
        })    
      },
  },
};
</script>


<style scoped>
.infoInput {
  width: 382px;
  min-height: 60px;
  height: auto;
  margin: 0 auto;
  margin-top: 18px;
}
.submitProblem {
    text-align: center
}
.submitProblem .el-button{
    width: 382px;
    height: 50px;
    font-size: 17px;
    margin-top: 35px;
}
</style>



// WEBPACK FOOTER //
// src/page/officialEmail/info/feedback.vue